import { useTranslation } from 'react-i18next';

import type { AdminLoginProps } from '@/types/pages';

import { Input } from '@/components';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const AdminLogin = (props: AdminLoginProps) => {
  const { login_url, authenticity_token, logo_url, icon_url } = props;

  const { t } = useTranslation();

  return (
    <main className="grid min-h-screen grid-cols-1 grid-rows-[auto_1fr] bg-white p-6 text-slate-900 md:grid-cols-2 md:grid-rows-1 md:p-8">
      <div className="relative flex items-start justify-center py-2 md:items-center md:py-0">
        <img
          className="mx-auto max-h-20 w-full max-w-35 object-contain md:max-h-none md:max-w-140"
          src={icon_url}
          alt="Sign in illustration"
        />
      </div>
      <div className="flex items-start justify-center md:items-center">
        <Card className="w-full max-w-120">
          <CardHeader>
            <CardTitle className="text-center">
              <img
                src={logo_url}
                className="mx-auto mb-2 block h-16 w-auto object-contain md:h-20"
                alt="Logo"
              />
              <h1 className="text-2xl font-semibold tracking-tight">
                {t('Sign In')}
              </h1>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form
              className="space-y-4"
              action={login_url}
              method="post"
            >
              <input
                type="hidden"
                name="authenticity_token"
                value={authenticity_token}
              />
              <div className="space-y-1.5">
                <Input
                  id="email"
                  name="user[email]"
                  label={t('Email')}
                  autoComplete="email"
                  required
                  autoFocus
                />
              </div>
              <div className="space-y-1.5">
                <Input
                  id="password"
                  name="user[password]"
                  type="password"
                  label={t('Password')}
                  required
                  autoComplete="current-password"
                />
              </div>
              <Button
                type="submit"
                variant="default"
                className="w-full"
              >
                {t('Sign In')}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};
